angular.module( 'acme.view.application.pos.create.pages.forms.membership', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pos.create.pages.forms.membership.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreatePagesFormsMembership = {
        name: 'application.pos.create.pages.forms.membership',
        url: '/membership',
        views: {
          "subview-main": {
            controller: 'posCreatePagesFormsMembershipController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/pages/forms/membership/membership.tpl.html'
          }
        },
        data: {
          pageTitle: '     ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(posCreatePagesFormsMembership);
});
